export default class MatchCorrectScoreMarketResultModel {
  public homeGoals: number = null;
  public awayGoals: number = null;
}
